import CheckCircleOutlineRoundedIcon from "@mui/icons-material/CheckCircleOutlineRounded";
import WarningAmberRoundedIcon from "@mui/icons-material/WarningAmberRounded";
import { Chip, CircularProgress, Tooltip } from "@mui/material";
import type { SmtpLoginStatus } from "../../../api/emailAccountsTypes";

interface Props {
  status?: SmtpLoginStatus;
}

const SmtpLoginChip = ({ status }: Props) => {
  switch (status) {
    case undefined:
      return <CircularProgress size={16} />;
    case "Present":
      return <Chip color="success" icon={<CheckCircleOutlineRoundedIcon />} label="SMTP" />;
    case "Absent":
      return <Chip variant="outlined" label="No SMTP" />;
    case "Unknown":
      return (
        <Tooltip title="Mailgun did not answer — reload to retry">
          <Chip variant="outlined" color="warning" icon={<WarningAmberRoundedIcon />} label="Unknown" />
        </Tooltip>
      );
  }
};

export default SmtpLoginChip;
